export const SEARCH_ROUTE = 'wyszukiwarka';
